import React from "react";
import { NavigationItem } from "../../../../constants";
import {
  COACH_PROGRAMS_PUBLISHED_ROUTE,
  COACH_PROGRAM_CURRICULUM_ROUTE,
  COACH_PROGRAM_ENROLLMENTS_ROUTE,
  COACH_PROGRAM_SETTING_ROUTE,
  COACH_PROGRAM_LIBRARY_TEMPLATE_CURRICULUM_ROUTE,
  COACH_PROGRAM_LIBRARY_TEMPLATE_SETTING_ROUTE,
  COACH_PROGRAM_LIBRARY_PUBLISHED_ROUTE,
} from "../../../routes";
import { useLocation } from "react-router-dom";
import InlineCounter from "../../../../components/loading/InlineCounter";

export const programsBreadcrumb: NavigationItem = {
  name: "Programs",
  link: COACH_PROGRAMS_PUBLISHED_ROUTE,
};

export const programLibraryBreadcrumb: NavigationItem = {
  name: "Program library",
  link: COACH_PROGRAM_LIBRARY_PUBLISHED_ROUTE,
};

export const useCoachProgramNavigation = (
  slug: string,
  enrollmentsCount: number,
  isTemplate: boolean = false,
): NavigationItem[] => {
  const location = useLocation();
  const isLibraryRoute = location.pathname.includes("/library/programs/");

  const curriculumRoute = isLibraryRoute
    ? COACH_PROGRAM_LIBRARY_TEMPLATE_CURRICULUM_ROUTE
    : COACH_PROGRAM_CURRICULUM_ROUTE;
  const settingsRoute = isLibraryRoute
    ? COACH_PROGRAM_LIBRARY_TEMPLATE_SETTING_ROUTE
    : COACH_PROGRAM_SETTING_ROUTE;

  const items: NavigationItem[] = [
    {
      name: "Curriculum",
      link: curriculumRoute.replace(":slug", slug),
    },
  ];

  if (!isTemplate) {
    items.push({
      name: (
        <InlineCounter
          label="Enrollments"
          count={enrollmentsCount}
          loading={!enrollmentsCount && enrollmentsCount !== 0}
        />
      ),
      link: COACH_PROGRAM_ENROLLMENTS_ROUTE.replace(":slug", slug),
    });
  }

  items.push({
    name: "Settings",
    link: settingsRoute.replace(":slug", slug),
  });

  return items;
};

export const coachProgramNavigation = (
  slug: string,
  enrollmentsCount: number,
  isTemplate: boolean = false,
): NavigationItem[] => {
  const isLibraryRoute =
    typeof window !== "undefined"
      ? window.location.pathname.includes("/library/programs/")
      : false;

  const curriculumRoute = isLibraryRoute
    ? COACH_PROGRAM_LIBRARY_TEMPLATE_CURRICULUM_ROUTE
    : COACH_PROGRAM_CURRICULUM_ROUTE;
  const settingsRoute = isLibraryRoute
    ? COACH_PROGRAM_LIBRARY_TEMPLATE_SETTING_ROUTE
    : COACH_PROGRAM_SETTING_ROUTE;

  const items: NavigationItem[] = [
    {
      name: "Curriculum",
      link: curriculumRoute.replace(":slug", slug),
    },
  ];

  if (!isTemplate) {
    items.push({
      name: (
        <InlineCounter
          label="Enrollments"
          count={enrollmentsCount}
          loading={!enrollmentsCount && enrollmentsCount !== 0}
        />
      ),
      link: COACH_PROGRAM_ENROLLMENTS_ROUTE.replace(":slug", slug),
    });
  }

  items.push({
    name: "Settings",
    link: settingsRoute.replace(":slug", slug),
  });

  return items;
};
